module.exports = __webpack_public_path__ + "static/img/fdmj.c92f6f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/fdmj.jpg
// module id = I/RN
// module chunks = 21